import React from 'react';

import {Monster} from '../../../generated/types';
import {CrToXp, getCr, splitAvgFormula, toMonsterLanguages, toMonsterSenses, toMonsterSpeed, toMonsterTypeLine} from '../../render-helpers';
import {MonsterBlockTable} from '../../monster-block-table';

import css from '../toolip.module.css';

type Props = {
	monster: Monster;
};

export const MonsterTooltip: React.FC<Props> = ({monster}) => {
	const [avgHp, formulaHp] = splitAvgFormula(monster.hp);
	return (
		<div className={css.wrapper}>
			<div>
				<div className={css.title}>{monster.title}</div>
				<em>{toMonsterTypeLine(monster)}</em>
			</div>
			<MonsterBlockTable
				params={{
					str: monster.str,
					dex: monster.dex,
					con: monster.con,
					int: monster.int,
					wis: monster.wis,
					cha: monster.cha,
				}}
				saves={monster.saves}
			/>
			<div className={css.table}>
				<div>
					<div className={css.header}>КО</div>
					<div className={css.value}>{getCr(monster.cr)}</div>
				</div>
				<div>
					<div className={css.header}>КБ</div>
					<div className={css.value}>{monster.ac}</div>
				</div>

				<div>
					<div className={css.header}>ПЗ</div>
					<div className={css.value}>
						{avgHp} (<small>{formulaHp}</small>)
					</div>
				</div>
				<div>
					<div className={css.header}>Скорость</div>
					<div className={css.value}>
						<small>{toMonsterSpeed(monster.speed)}</small>
					</div>
				</div>
			</div>
			<div>
				<div>
					<b>Восприятие</b> {toMonsterSenses(monster.passive, monster.senses)}
				</div>
			</div>
			<div>
				<b>Языки</b>{' '}
				{monster.languages || monster.understandLanguages || monster.telepathy
					? `${toMonsterLanguages(monster.languages, monster.understandLanguages, monster.telepathy)}`
					: '—'}
			</div>
		</div>
	);
};
